// Staff Role Constants
export const INACTIVE_USER_ROLE = -1
export const SYSTEM_ADMIN_ROLE = 0
export const APP_MANAGER_ROLE = 1
export const ENTERPRISE_ADMIN_ROLE = 2
export const ORGANIZATION_ADMIN_ROLE = 3
export const ORGANIZATION_SUPERVISOR_ROLE = 4
export const ORGANIZATION_STAFF_ROLE = 6
export const ORGANIZATION_VOLUNTEER_ROLE = 7
export const PARTNER_ADMIN_ROLE = 9
export const AUTHENTICATED_PARTNER_USER_ROLE = 10
export const AUTHENTICATED_USER_ROLE = 100
// Source: https://team-1607816385495.atlassian.net/wiki/spaces/DEV/pages/1995112455/SOAR+User+Roles

//Helper function to Check if a user role indicates an app manager or (optionally) higher access
export function isAppManager(staff_role, orAbove) {
  return isRole(staff_role, APP_MANAGER_ROLE, orAbove)
}

export function isPartnerAdmin(staff_role) {
  return staff_role === PARTNER_ADMIN_ROLE
}

//Helper function to check if a user role indicates an enterprise admin or (optionally) higher access
export function isEnterpriseAdmin(staff_role, orAbove) {
  return isRole(staff_role, ENTERPRISE_ADMIN_ROLE, orAbove)
}

function isRole(staff_role, role, orAbove) {
  let result = false

  if (orAbove) {
    result = staff_role <= role
  } else {
    result = staff_role === role
  }

  return result
}
